import { NavigationControl } from "react-map-gl";

const CustomNavigationControl = () => {
  return <NavigationControl position="bottom-right" showCompass={false} />;
};

export default CustomNavigationControl;
